
export enum InvoiceTypeConstants {
    net = 1,
    gross = 2
}

export const InvoiceTypeDisplayNames = {
    InvoiceTypeDisplayNameNet: $localize`Netto`,
    InvoiceTypeDisplayNameGross: $localize`Brutto`,
}

export class InvoiceType {
    public Id: number;
    public DisplayName: string;
}
